import { styled } from '@clickcease/cc-client-components-lib'

export const PaidMarketingDataStyled = styled('div', {
  display: 'flex',

  '> div': {
    marginRight: '$4',
  },
})

export const TrialPreEndModalCardNumber = styled('div', {
  fontSize: '32px',
  fontWeight: '$sb',
  width: '42px',
  marginTop: '$16',
})

export const TrialPreEndModalCardText = styled('div', {
  textSize: '$lg',
  fontWeight: '$l',

  span: {
    fontWeight: '$sb',
  },

  variants: {
    bundle: {
      true: {
        width: '120px',
      },
    },
  },
})

export const TrialPreEndModalCardTextWrapper = styled('div', {
  display: 'flex',
})
